var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.90909 0C2.0263 0 0.5 1.567 0.5 3.5V5.83333H25.5V3.5C25.5 1.567 23.9737 0 22.0909 0H3.90909ZM25.5 8.16667H0.5V17.5C0.5 19.433 2.0263 21 3.90909 21H22.0909C23.9737 21 25.5 19.433 25.5 17.5V8.16667ZM8.45455 14.5833C8.45455 15.5498 7.69139 16.3333 6.75 16.3333C5.80861 16.3333 5.04545 15.5498 5.04545 14.5833C5.04545 13.6168 5.80861 12.8333 6.75 12.8333C7.69139 12.8333 8.45455 13.6168 8.45455 14.5833ZM12.4318 16.3333C13.3732 16.3333 14.1364 15.5498 14.1364 14.5833C14.1364 13.6168 13.3732 12.8333 12.4318 12.8333C11.4904 12.8333 10.7273 13.6168 10.7273 14.5833C10.7273 15.5498 11.4904 16.3333 12.4318 16.3333Z",
    fill: "url(#paint0_radial_5518_3850)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5518_3850",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13 10.5) rotate(90) scale(10.5 12.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8ADC7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.98e25991304b7cad6ebbf2e77288e00d.svg";
export { ForwardRef as ReactComponent };